import { Link } from "react-router-dom";
import { useTranslation } from "../../../i18n/useTranslation";

const col = "flex flex-col gap-2";
const item = "text-[13px] tracking-[0.03em] opacity-90 hover:opacity-100";

const Menu = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 px-5 py-10 text-left">
        <div>
          <div className="eyebrow">{t("footer.company")}</div>
          <div className={col}>
            <Link className={item} to="/trusted-ecosystem">{t("nav.trustedEcosystem")}</Link>
            <Link className={item} to="/trusted-ecosystem#promise">{t("footer.promise")}</Link>
            <Link className={item} to="/trusted-ecosystem#values">{t("footer.values")}</Link>
            <Link className={item} to="/solutions">{t("nav.solutions")}</Link>
            <Link className={item} to="/markets">{t("nav.markets")}</Link>
            <Link className={item} to="/careers">{t("footer.careers")}</Link>
          </div>
        </div>

        <div>
          <div className="eyebrow">{t("footer.solutions")}</div>
          <div className={col}>
            <Link className={item} to="/solutions/deviceworks">DeviceWorks</Link>
            <Link className={item} to="/solutions/itrust-id">iTrust.ID</Link>
          </div>
        </div>

        <div>
          <div className="eyebrow">{t("footer.markets")}</div>
          <div className={col}>
            <Link className={item} to="/markets/global">Tapaswe Global</Link>
            <Link className={item} to="/markets/india">Tapaswe Bharat</Link>
            <Link className={item} to="/markets/usa">Tapaswe USA</Link>
          </div>
        </div>

        <div>
          <div className="eyebrow">{t("footer.legalTrust")}</div>
          <div className={col}>
            <Link className={item} to="/data-sovereignty">{t("footer.dataSovereignty")}</Link>
            <Link className={item} to="/privacy">{t("footer.privacyPolicy")}</Link>
            <Link className={item} to="/terms">{t("footer.termsOfUse")}</Link>
          </div>
        </div>
      </div>

      <div className="flex justify-center gap-6 pb-8">
        <Link to="/contact" className="btn-outline">{t("footer.contactUs")}</Link>
        <Link to="/invest" className="btn-outline">{t("footer.invest")}</Link>
      </div>
    </>
  );
};

export default Menu;
